'use strict';

import corteAnual from './corteAnual.component';

const corteAnualModule = angular
  .module('app.corteAnual', [])
  .component('corteAnual', corteAnual)
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('corteAnual', {
        url: '/corte_anual',
        component: 'corteAnual'
      });
    $urlRouterProvider.otherwise('/');
  })
  .directive('fileModel', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
        element.bind('change', function(){
          scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
          });
        });
      }
    }
  }])
  .service('fileUpload', ['$http', function ($http) {
    this.uploadFileToUrl = function (file, uploadUrl) {
      var fd = new FormData();
      fd.append('file', file);
      $http.post(uploadUrl, fd, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      })
      .success(function () {
      })
      .error(function () {
      });
    }
  }])
  .name;

export default corteAnualModule;


// WEBPACK FOOTER //
// ./src/app/components/listados/corte_anual/corteAnual.module.js